import {
  SettingsDrillRow,
  SettingsGroup,
  SettingsPageFrame,
} from '@eluve/blocks';
import { GeneralTenantSettings } from '@eluve/frontend-feature-tenants';
import { useTranslation } from '@eluve/i18n';
import { FeatureFlaggedComponent } from '@eluve/smart-blocks';

export const OrganizationGeneralPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <SettingsPageFrame title={t('settings.nav.organization')}>
      <GeneralTenantSettings />
      <FeatureFlaggedComponent flag="LOCATIONS">
        <SettingsGroup title={t('settings.organization.layers')}>
          <SettingsDrillRow
            title={t('settings.organization.layers')}
            description={t('settings.organization.layersDescription')}
            to="layers"
          />
        </SettingsGroup>
      </FeatureFlaggedComponent>
    </SettingsPageFrame>
  );
};
